import styled from "styled-components";
import PropTypes from "prop-types";

import { Placeholder } from "components/Placeholder";

const TablePlaceholderContainer = styled.div`
  .order-table {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.8em;
    margin-bottom: 10px;

    .placeholder-glow {
      flex: 1;
    }

    .symbol,
    .side {
      width: 200px;
    }
  }
`;

const RowPlaceholder = ({ maxWidth, minWidth }) => {
  return (
    <TablePlaceholderContainer>
      <Placeholder
        size="lg"
        col={{ xs: 12, lg: 12 }}
        className="placeholder-custom"
        style={{
          maxWidth,
          minWidth,
        }}
      />
    </TablePlaceholderContainer>
  );
};

RowPlaceholder.propTypes = {
  maxWidth: PropTypes.number,
  minWidth: PropTypes.number,
};

export const TablePlaceholder = ({ headers }) => {
  const headerCount = headers.length;

  const placeholders = Array.from({ length: 3 }, (_, index) => (
    <tr key={index}>
      {Array.from({ length: headerCount }, (_, i) => {
        const cell = headers[i].column.columnDef;
        return (
          <td
            key={i}
            style={{
              maxWidth: cell.maxWidth,
              minWidth: cell.minWidth,
            }}
            className="placeholder-row"
          >
            <RowPlaceholder maxWidth={cell.maxWidth} minWidth={cell.minWidth} />
          </td>
        );
      })}
    </tr>
  ));

  return <>{placeholders}</>;
};

TablePlaceholder.propTypes = { headers: PropTypes.any };
